<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card>
      <v-card-title> Finance Close out </v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <template>
          <v-container fluid>
            <v-row justify="space-around" class="mt-5 mb-5">
              <v-card
                class="d-flex justify-space-between pa-2"
                outlined
                rounded="lg"
                color="#8C000D"
                max-width="150px"
              >
                <div d-flex class="pa-3 ml-2">
                  <div>
                    <h3 class="font-weight-medium white--text">EBT</h3>
                    <span class="subtitle-1 white--text">
                      {{ financeSideData.EBT }}
                    </span>
                    <br />
                  </div>
                </div>
              </v-card>
              <v-card
                class="d-flex justify-space-between pa-2"
                outlined
                rounded="lg"
                color="#0B3866"
                max-width="150px"
              >
                <div d-flex class="pa-3 ml-2">
                  <div>
                    <h3 class="font-weight-medium white--text">DC</h3>
                    <span class="subtitle-1 white--text">
                      {{ financeSideData.DebitCard }}
                    </span>
                    <br />
                  </div>
                </div>
              </v-card>
              <v-card
                class="d-flex justify-space-between pa-2"
                outlined
                rounded="lg"
                color="#52A65E"
                max-width="150px"
              >
                <div d-flex class="pa-3 ml-2">
                  <div>
                    <h3 class="font-weight-medium white--text">Cash</h3>
                    <span class="subtitle-1 white--text">
                      {{ financeSideData.Cash }}
                    </span>
                    <br />
                  </div>
                </div>
              </v-card>
            </v-row>
            <v-row>
              <v-col cols="4" class="pa-0">
                <v-subheader class="mt-4 pa-0">Transfer to</v-subheader>
              </v-col>
              <v-col cols="8">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="month"
                      label="Month"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      :rules="rules"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    type="month"
                    v-model="date"
                    :active-picker.sync="monthPicker"
                    @change="saveMonth"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  outlined
                  label="Notes"
                  v-model="notes"
                  rows="4"
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          :loading="isLoading"
          :disabled="isLoading"
          color="primary"
          @click="closeOut"
        >
          Closeout and Transfer
          <template v-slot:loader>
            <span>Updating...</span>
          </template>
        </v-btn>
        <v-btn color="primary" text @click="closeDialog"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  props: {
    financeItemData: {
      type: Array,
      default: () => [],
    },
    financeID: {
      type: String,
    },
  },
  data() {
    return {
      monthPicker: null,
      date: null,
      menu: false,
      month: null,
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      minDate: null,
      maxDate: null,
      selectedDate: null,
      rules: [],
      notes: "",
      staff: localStorage.getItem("Name"),
      clientID: this.$route.params.clientID,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      dialog: "finances/isCloseOutDialogOpen",
      getFinanceData: "finances/finances",
    }),

    financeSideData() {
      let initialValue = parseFloat(0).toFixed(2);

      const filterFinances = this.financeItemData.find(
        (item) => item._id === this.financeID
      );

      let Cash = parseFloat(filterFinances?.Cash?.$numberDecimal).toFixed(2);
      let EBT = parseFloat(filterFinances?.EBT?.$numberDecimal).toFixed(2);
      let DebitCard = parseFloat(
        filterFinances?.DebitCard?.$numberDecimal
      ).toFixed(2);

      return {
        Cash: isNaN(Cash) ? initialValue : Cash,
        EBT: isNaN(EBT) ? initialValue : EBT,
        DebitCard: isNaN(DebitCard) ? initialValue : DebitCard,
      };
    },
  },

  methods: {
    ...mapActions({
      addFinanceRolloverTransaction:
        "financeTransactions/addFinanceRolloverTransaction",
      addFinance: "finances/addFinance",
      addFinanceFromRollOver: "finances/addFinanceFromRollOver",
    }),

    closeDialog() {
      this.clear();
      this.$store.dispatch("finances/setCloseOutDialog", false);
    },
    saveMonth(date) {
      this.minDate = moment(date).startOf("month").format("YYYY-MM-DD");

      this.maxDate = moment(date).endOf("month").format("YYYY-MM-DD");

      const newDate = moment(this.minDate);
      this.month = this.monthNames[newDate.month()];

      this.selectedDate = this.minDate;

      this.validateDate();
    },

    validateDate() {
      const getMonth = (date) => {
        return moment(date).month() + 1;
      };

      const getYear = (date) => {
        return moment(date).year();
      };

      let newMonth = getMonth(this.selectedDate);
      let newYear = getYear(this.selectedDate);

      const date = this.getFinanceData.find((item) => {
        let itemMonth = getMonth(item.Date);
        let itemYear = getYear(item.Date);
        if (newMonth === itemMonth && newYear === itemYear) {
          return true;
        }
      });

      if (date) {
        this.rules = ["Date already added for this month"];
      } else {
        this.rules = [true];
      }
    },

    async closeOut() {
      this.isLoading = true;
      let defaultItem = {
        ClientID: this.clientID,
        Notes: this.notes,
        StaffSignature: `${this.staff} - ${new Date()}`,
      };

      let rolloverItem = {
        TransactionType: "Deposit",
        DepositCategory: "Rollover",
      };

      let closeOutItem = {
        TransactionType: "Expense",
        ExpenseCategory: "Rollover",
      };

      try {
        let data = {
          newMonthlyRegister: {
            ...defaultItem,
            Date: moment.utc(this.selectedDate),
            Month: this.month,
          },
          updatedMonthlyRegister: { CloseOut: true },
          newFinanceTransaction: {
            ...defaultItem,
            ...rolloverItem,
            Date: new Date(),
          },
          updatedFinanceTransaction: {
            ...defaultItem,
            ...closeOutItem,
            Date: new Date(),
          },
          balances: this.financeSideData,
        };

        const response = await this.addFinanceFromRollOver({
          data,
          id: this.financeID,
        });
        console.log(response);
        this.isLoading = false;
        this.$emit("initialized");
        this.closeDialog();
      } catch (error) {
        this.closeDialog();
        console.log(error);
        this.isLoading = false;
      }

      this.$emit("initialized");
      this.closeDialog();
    },

    clear() {
      this.rules = [];
      this.month = null;
    },
  },
};
</script>
